function getFocusableElements() {
  const focusableElements = Array.from(document.querySelectorAll(
    `a[href]:not([tabindex='-1']),
    area[href]:not([tabindex='-1']),
    input:not([type='hidden']):not([disabled]):not([tabindex='-1']),
    select:not([disabled]):not([tabindex='-1']),
    textarea:not([disabled]):not([tabindex='-1']),
    button:not([disabled]):not([tabindex='-1']),
    object:not([tabindex='-1']),
    iframe:not([tabindex='-1']),
    [tabindex]:not([disabled]):not([tabindex='-1']),
    [contentEditable=true]:not([tabindex='-1'])`
  ));

  if(focusableElements.length) {
    focusableElements.sort((elementA, elementB) => {
      const elementATabIndex = elementA.tabIndex;
      const elementBTabIndex = elementB.tabIndex;

      if(elementATabIndex === elementBTabIndex)
        return 0;
      if(elementATabIndex < elementBTabIndex)
        return -1;
      if(elementATabIndex > elementBTabIndex)
        return 1;
    });
  }

  return focusableElements;
}

function focusElement(indexDelta) {
  const focusableElements = getFocusableElements();
  const currentIndex = focusableElements.indexOf(this);
  let newIndex = currentIndex + indexDelta;

  if(newIndex > focusableElements.length)
    newIndex = 0;
  else if(newIndex < 0)
    newIndex = focusableElements.length;

  const newElement = focusableElements[newIndex];
  if(newElement) {
    newElement.focus();
    return document.activeElement === newElement;
  }

  return false;
}

export function focusNextElement() {
  return focusElement.call(this, +1);
}

export function focusPreviousElement() {
  return focusElement.call(this, -1);
}
